import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    CustomPartCategoriesRuntype,
    CustomPartCategoryPostRuntype,
    CustomPartCategoryRuntype,
    CustomPartCategoryUpdateRuntype,
} from './customPartCategoryBackendTypes';

export const customPartCategoryEndpoints = {
    'GET /custom-part-categories': endpoint({
        description: 'Get all custom part categories',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: CustomPartCategoriesRuntype,
    }),

    'POST /custom-part-categories': endpoint({
        description: 'Create a new custom part category',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CustomPartCategoryPostRuntype,
        responseBody: CustomPartCategoryRuntype,
        invalidates: ['GET /custom-part-categories'],
    }),

    'GET /custom-part-categories/:id': endpoint({
        description: 'Get a custom part category by id',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: CustomPartCategoryRuntype,
    }),

    'PATCH /custom-part-categories/:id': endpoint({
        description: 'Update a custom part category',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: CustomPartCategoryUpdateRuntype,
        responseBody: CustomPartCategoryRuntype,
        invalidates: ['GET /custom-part-categories'],
    }),

    'DELETE /custom-part-categories/bulk': endpoint({
        description: 'Delete a custom part category',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({ ids: z.array(z.string()) }),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /custom-part-categories'],
    }),
};
